import classes from "./Button.module.css"
import Colors from "values/Colors"
import "@fontsource/roboto"
import { useState } from "react";

const Button = ({ children, onClick, color = Colors.blue2, className = '', disabled = false, ...props }) => {

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        if (!disabled) {
            setIsHovered(true);
        }
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };

    const buttonColor = disabled ? '#ccc' : (isHovered ? 'var(--hover-color, #81a8ec)' : color);
    const cursorStyle = disabled ? 'not-allowed' : 'pointer';
    const opacity = disabled ? 0.6 : 1;

    return (
        <div onClick={handleClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}
        className={className ? `${className} ${classes.style__button}` : classes.style__button}
        style={{ borderColor: buttonColor, cursor: cursorStyle, opacity: opacity, ...props.style }}>
            <span style={{ color: buttonColor }} className={classes.text__style}>{children}</span>
        </div >

    )
}

export default Button